<template>
  <div
    class="two-columns-page-layout container row"
    :class="{ 'two-columns-page-layout--bottom-padding': !innerPadding }"
  >
    <div
      data-test-two-columns-page-layout-left
      class="two-columns-page-layout__left-column small-12 medium-12 large-6"
      :class="{ 'two-columns-page-layout--bottom-padding': innerPadding }"
    >
      <slot name="left" />
    </div>
    <div data-test-two-columns-page-layout-right class="small-12 medium-12 large-5 large-offset-1">
      <slot name="right" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TwoColumnsPageLayout',
  props: {
    innerPadding: {
      type: Boolean,
      default: () => false
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all.scss';

.two-columns-page-layout {
  padding-top: rem-calc(60);

  &--bottom-padding {
    padding-bottom: rem-calc(180);
  }

  @include breakpoint(medium down) {
    padding-right: 0;
    padding-left: 0;
  }

  &__left-column {
    @include breakpoint(medium down) {
      padding-left: rem-calc(20);
      padding-right: rem-calc(20);
    }
  }
}
</style>
